export default __webpack_public_path__ + "static/media/banner-170x340-bg-orange-template.eae2eef3.svg";